/* The Sugar Coated Cult. Vanilla JS, no library. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  var RM = root.classList.contains('rm');
  var FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- Title sequence (home, once a session) ---------- */
  if (root.classList.contains('ttl-on')) {
    if (!$('.ttl')) root.classList.remove('ttl-on');
    else {
      var endTitle = function () { root.classList.add('ttl-done'); root.classList.remove('ttl-on'); };
      try { sessionStorage.setItem('tscc-ttl', '1'); } catch (e) {}
      var tb = $('.ttl button'); if (tb) tb.addEventListener('click', endTitle);
      doc.addEventListener('keydown', endTitle, { once: true });
      $('.ttl').addEventListener('click', endTitle);
      setTimeout(endTitle, 4400);
    }
  }

  /* ---------- Page change: cut to black with a slate ---------- */
  var veil = $('.veil'), veilT = $('[data-veil-t]');
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !veil || RM || EDITOR || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button || a.target || a.hasAttribute('download')) return;
    if (a.origin !== location.origin || !/^https?:$/.test(a.protocol)) return;
    if (a.hasAttribute('data-cart-open') && $('.cart')) return;
    if (a.pathname === location.pathname && a.search === location.search && a.hash) return;
    e.preventDefault();
    var href = a.href;
    if (veilT) veilT.textContent = a.getAttribute('data-slate') || veil.getAttribute('data-default') || '';
    root.classList.remove('cart-open');
    root.classList.add('leaving-pre');
    void veil.offsetWidth;
    root.classList.remove('leaving-pre'); root.classList.add('leaving');
    setTimeout(function () { location.href = href; }, 440);
  });
  addEventListener('pageshow', function (e) { if (e.persisted) { root.classList.remove('leaving'); refresh(); } });

  /* ---------- Cursor (mouse only) ---------- */
  if (FINE && $('.cur') && $('.curx')) {
    /* Crosses that move together. The lowest is painted in "difference": brand orange over black, black over brand orange, to the pixel.
       Above it, a plain orange copy shows only over cream grounds and a plain black copy only over photographs, where difference would turn blue. */
    var cur = $('.cur'), curX = $('.curx'), curT = $('.cur__t'), curK = $('.cur__k'), curI = $('.cur__i'), mx = -99, my = -99, HALF = 40;
    var CREAM = '.s-cream, .cart', PHOTO = '.card__pic:not(.card__pic--wire), .gal__t, .seq__stage, .scan, .ci img';
    var clip = function (el, sel) {
      var l = 1e9, t = 1e9, r = -1e9, b = -1e9, hit = false;
      $$(sel).forEach(function (n) {
        var q = n.getBoundingClientRect();
        if (!q.width || q.right < mx - HALF || q.left > mx + HALF || q.bottom < my - HALF || q.top > my + HALF) return;
        hit = true; l = Math.min(l, q.left); t = Math.min(t, q.top); r = Math.max(r, q.right); b = Math.max(b, q.bottom);
      });
      if (!hit) { el.style.clipPath = 'inset(100%)'; return; }
      var x0 = mx - HALF, y0 = my - HALF, side = HALF * 2;
      el.style.clipPath = 'inset(' + clamp(t - y0, 0, side) + 'px ' + clamp(x0 + side - r, 0, side) + 'px ' + clamp(y0 + side - b, 0, side) + 'px ' + clamp(l - x0, 0, side) + 'px)';
    };
    var zone = function () { clip(curK, CREAM); if (curI) clip(curI, PHOTO); };
    var zT = false;
    addEventListener('scroll', function () { if (!zT) { zT = true; requestAnimationFrame(function () { zT = false; zone(); }); } }, { passive: true });
    doc.addEventListener('mousemove', function (e) {
      root.classList.add('has-cur'); mx = e.clientX; my = e.clientY;
      cur.style.transform = curX.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      var t = e.target.closest ? e.target.closest('[data-cur], a, button, summary, label, input, select') : null;
      var tag = t && t.getAttribute('data-cur');
      [cur, curX].forEach(function (c) { c.classList.toggle('on', !!t); c.classList.toggle('tag', !!tag); });
      if (tag) { curT.textContent = tag; curK.style.clipPath = 'none'; if (curI) curI.style.clipPath = 'inset(100%)'; } else zone();
    }, { passive: true });
    doc.addEventListener('mousedown', function () { cur.classList.add('down'); curX.classList.add('down'); });
    doc.addEventListener('mouseup', function () { cur.classList.remove('down'); curX.classList.remove('down'); });
    doc.addEventListener('mouseleave', function () { root.classList.remove('has-cur'); });
  }

  /* ---------- Reveals ---------- */
  var showAll = function (c) { $$('[data-r], [data-lines]', c).forEach(function (el) { el.classList.add('in'); }); };
  if ('IntersectionObserver' in window && !RM && !EDITOR) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target.__r || en.target; t.classList.add('in'); io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-r], [data-lines]').forEach(function (el) {
      if (el.classList.contains('scan')) { el.parentElement.__r = el; io.observe(el.parentElement); } else io.observe(el);
    });
  } else showAll();
  if (EDITOR) doc.addEventListener('shopify:section:load', function (e) { showAll(e.target); });

  /* ---------- Halftone fields: one response to the pointer, shared by the opening canvas and the still fields ---------- */
  var FIELD = { radius: 150, gain: 0.55 };
  $$('img[data-swell]').forEach(function (img) {
    if (RM) return;
    var cvs = doc.createElement('canvas'), c2 = cvs.getContext && cvs.getContext('2d');
    if (!c2) return;
    var host = img.closest('section') || img.parentElement, raster = doc.createElement('canvas'), rc = raster.getContext('2d');
    var W = 0, H = 0, dpr = 1, ready = false, px = 0, py = 0, amp = 0, want = 0, run = false, RINGS = 12;
    cvs.className = img.className; cvs.setAttribute('aria-hidden', 'true'); cvs.style.visibility = 'hidden';
    cvs.style.aspectRatio = img.getAttribute('width') + ' / ' + img.getAttribute('height');
    if (img.hasAttribute('data-par')) cvs.setAttribute('data-par', img.getAttribute('data-par'));
    img.parentNode.insertBefore(cvs, img.nextSibling);
    function still() { c2.setTransform(1, 0, 0, 1, 0, 0); c2.clearRect(0, 0, cvs.width, cvs.height); c2.drawImage(raster, 0, 0); }
    function build() {
      dpr = Math.min(devicePixelRatio || 1, 2); W = cvs.clientWidth; H = cvs.clientHeight;
      if (!W || !H || !img.naturalWidth) return;
      cvs.width = raster.width = Math.round(W * dpr); cvs.height = raster.height = Math.round(H * dpr);
      rc.clearRect(0, 0, raster.width, raster.height); rc.drawImage(img, 0, 0, raster.width, raster.height);
      still();
      if (!ready) { ready = true; cvs.style.visibility = ''; img.style.visibility = 'hidden'; }
    }
    function frame() {
      amp += (want - amp) * 0.16;
      if (!want && amp < 0.01) amp = 0;
      still();
      if (amp) {
        for (var k = 1; k <= RINGS; k++) {
          var rr = FIELD.radius * (1 - (k - 1) / RINGS), sc = 1 + (k / RINGS) * FIELD.gain * 0.6 * amp;
          c2.save(); c2.beginPath(); c2.arc(px * dpr, py * dpr, rr * dpr, 0, 6.2832); c2.clip();
          c2.clearRect(0, 0, cvs.width, cvs.height);
          c2.drawImage(raster, (px - px * sc) * dpr, (py - py * sc) * dpr, cvs.width * sc, cvs.height * sc);
          c2.restore();
        }
      }
      if (amp || want) requestAnimationFrame(frame); else run = false;
    }
    var wake = function () { if (ready && !run) { run = true; requestAnimationFrame(frame); } };
    if (img.complete && img.naturalWidth) build(); else img.addEventListener('load', build);
    var rz; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { if (ready) build(); }, 160); });
    host.addEventListener('pointermove', function (e) { var b = cvs.getBoundingClientRect(); px = e.clientX - b.left; py = e.clientY - b.top; want = 1; wake(); }, { passive: true });
    host.addEventListener('pointerleave', function () { want = 0; wake(); });
    host.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') setTimeout(function () { want = 0; wake(); }, 500); });
    host.addEventListener('pointercancel', function () { want = 0; wake(); });
  });

  /* ---------- Parallax of the halftone blocks (transform only) ---------- */
  var pars = $$('[data-par]');
  if (pars.length && !RM) {
    var pt = false;
    var par = function () {
      pt = false; var vh = innerHeight;
      pars.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var d = (r.top + r.height / 2 - vh / 2) * parseFloat(el.getAttribute('data-par'));
        el.style.transform = 'translate3d(0,' + d.toFixed(1) + 'px,0)';
      });
    };
    addEventListener('scroll', function () { if (!pt) { pt = true; requestAnimationFrame(par); } }, { passive: true });
    par();
  }

  /* ---------- Timecode ---------- */
  var tc = $('[data-tc]');
  if (tc && !RM) {
    var t0 = Date.now(), p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    setInterval(function () {
      if (doc.hidden) return;
      var f = Math.floor((Date.now() - t0) / 41.67), s = Math.floor(f / 24);
      tc.textContent = '00:' + p2(Math.floor(s / 60) % 60) + ':' + p2(s % 60) + ':' + p2(f % 24);
    }, 84);
  }

  /* ---------- Halftone canvas: the brand's dots, printing its own logo and objects ---------- */
  var cv = $('[data-halftone]');
  if (cv && window.TSCC_MAPS && cv.getContext) {
    (function () {
      var N = 120, names = ['logo', 'meteorite', 'logo', 'key', 'logo', 'box'];
      var cache = {};
      var M = names.map(function (n) {
        if (cache[n]) return cache[n];
        var s = atob(window.TSCC_MAPS[n]), a = new Uint8Array(N * N);
        for (var i = 0; i < a.length; i++) a[i] = s.charCodeAt(i);
        return (cache[n] = a);
      });
      var ctx = cv.getContext('2d'), W, H, cell, size, ox, oy, px = -999, py = -999, run = false, last = 0, start = 0;
      var HOLD = 3400, SCAN = 1300;
      function fit() {
        var dpr = Math.min(devicePixelRatio || 1, 2);
        W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var wide = W >= 900;
        size = wide ? Math.min(H * 0.9, W * 0.5) : Math.min(W * 0.82, H * 0.36);
        cell = Math.max(5, size / (wide ? 92 : 58));
        ox = wide ? W * 0.72 - size / 2 : (W - size) / 2; oy = wide ? (H - size) / 2 - H * 0.02 : H * 0.045;
      }
      function val(m, x, y) {
        var u = (x - ox) / size * N, v = (y - oy) / size * N;
        if (u < 0 || v < 0 || u >= N || v >= N) return 0;
        return m[(v | 0) * N + (u | 0)] / 255;
      }
      function draw(t) {
        var el = Math.max(0, t - start), k = Math.floor(el / (HOLD + SCAN)) % M.length, ph = el % (HOLD + SCAN);
        var A = M[k], B = M[(k + 1) % M.length];
        var scanY = ph > HOLD ? ((ph - HOLD) / SCAN) * (H + 40) - 20 : -40;
        var gl = !RM && Math.random() < 0.05, gy = Math.random() * H, gh = 20 + Math.random() * 60, gx = (Math.random() - 0.5) * 40;
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#FF6D00'; ctx.beginPath();
        var row = 0, x, y, v, r, d, sx;
        for (y = cell / 2; y < H; y += cell * 0.866, row++) {
          sx = (gl && y > gy && y < gy + gh) ? gx : 0;
          for (x = (row % 2 ? cell / 2 : 0); x < W + cell; x += cell) {
            v = val(y < scanY ? B : A, x, y);
            v = v * 0.94 + 0.035;
            if (px > -900) { d = Math.hypot(x - px, y - py); if (d < FIELD.radius) v += (1 - d / FIELD.radius) * FIELD.gain * (0.4 + v); }
            if (scanY > 0 && Math.abs(y - scanY) < cell * 3) v += 0.25;
            r = Math.min(v, 1.15) * cell * 0.6;
            if (r < 0.45) continue;
            ctx.moveTo(x + sx + r, y); ctx.arc(x + sx, y, r, 0, 6.2832);
          }
        }
        ctx.fill();
        if (scanY > 0) { ctx.fillStyle = '#EEEFC6'; ctx.fillRect(0, scanY, W, 1.5); }
      }
      function loop(t) {
        if (!run) return;
        if (t - last > 32) { last = t; draw(t); }
        requestAnimationFrame(loop);
      }
      fit(); cv.parentElement.classList.add('live');
      if (RM) { start = 0; draw(100); addEventListener('resize', function () { fit(); draw(100); }); return; }
      start = performance.now() + (root.classList.contains('ttl-on') ? 4300 : 600);
      new IntersectionObserver(function (es) {
        var on = es[0].isIntersecting;
        if (on && !run) { run = true; requestAnimationFrame(loop); } else if (!on) run = false;
      }).observe(cv);
      var rz; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(fit, 150); });
      var host = cv.closest('.hero') || cv;
      host.addEventListener('pointermove', function (e) { var b = cv.getBoundingClientRect(); px = (e.clientX - b.left) * (W / b.width); py = (e.clientY - b.top) * (H / b.height); }, { passive: true });
      host.addEventListener('pointerleave', function () { px = py = -999; });
      host.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') setTimeout(function () { px = py = -999; }, 500); });
    })();
  }

  /* ---------- Sequence: scroll-scrubbed with a mouse on a wide window, stop-motion elsewhere ---------- */
  $$('[data-seq]').forEach(function (seq) {
    var imgs = $$('.seq__stage img', seq), caps = $$('.seq__caps li', seq), hud = $('[data-seq-n]', seq), range = $('.seq__range', seq);
    var hold = seq.closest('.seq-hold'), n = imgs.length, cur = -1;
    if (!n) return;
    var p2 = function (v) { return (v < 10 ? '0' : '') + v; };
    function set(i) {
      i = clamp(i, 0, n - 1); if (i === cur) return; cur = i;
      imgs.forEach(function (im, j) { im.classList.toggle('on', j === i); });
      var c = Math.min(caps.length - 1, Math.floor(i / n * caps.length));
      caps.forEach(function (li, j) { li.classList.toggle('on', j === c); });
      if (hud) hud.textContent = p2(i + 1) + ' / ' + p2(n);
      if (range) range.value = i;
    }
    set(RM ? n - 1 : 0);
    if (RM) return;
    imgs.forEach(function (im) { im.loading = 'eager'; });
    var fine = FINE && !EDITOR && matchMedia('(min-width: 1000px)').matches && innerHeight >= 620;
    if (fine && hold) {
      hold.classList.add('fine');
      var tick = false;
      var on = function () {
        tick = false; var r = hold.getBoundingClientRect();
        set(Math.floor(clamp(-r.top / (r.height - innerHeight), 0, 0.999) * n));
      };
      addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(on); } }, { passive: true });
      on();
    } else {
      var timer = null;
      var step = function () { var nx = cur + 1; if (nx >= n) { nx = 0; } set(nx); timer = setTimeout(step, nx === n - 1 ? 2200 : nx === 0 ? 1200 : 520); };
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !timer && !seq.__stop) timer = setTimeout(step, 700);
        else if (!es[0].isIntersecting) { clearTimeout(timer); timer = null; }
      }, { threshold: 0.5 }).observe($('.seq__stage', seq));
      if (range) range.addEventListener('input', function () { seq.__stop = true; clearTimeout(timer); set(+range.value); });
    }
  });

  /* ---------- Member card: follows the pointer; on touch it turns with the scroll ---------- */
  var mc = $('.mcard');
  if (mc && !RM) {
    var mw = mc.parentElement;
    var tilt = function (nx, ny) { mc.style.setProperty('--ry', (nx * 26).toFixed(1) + 'deg'); mc.style.setProperty('--rx', (-ny * 18).toFixed(1) + 'deg'); mc.style.setProperty('--sx', (nx * 40).toFixed(1) + '%'); };
    if (FINE) {
      mw.addEventListener('pointermove', function (e) { var b = mw.getBoundingClientRect(); mc.classList.add('live'); tilt((e.clientX - b.left) / b.width - 0.5, (e.clientY - b.top) / b.height - 0.5); });
      mw.addEventListener('pointerleave', function () { mc.classList.remove('live'); mc.style.cssText = ''; });
    } else {
      var mt = false;
      addEventListener('scroll', function () {
        if (mt) return; mt = true;
        requestAnimationFrame(function () { mt = false; var b = mw.getBoundingClientRect(); if (b.bottom < 0 || b.top > innerHeight) return; mc.classList.add('live'); var p = clamp((b.top + b.height / 2) / innerHeight, 0, 1) - 0.5; tilt(p * 1.3, -p * 0.5); });
      }, { passive: true });
    }
  }
  $$('[data-cardno]').forEach(function (el) {
    var n; try { n = localStorage.getItem('tscc-no'); if (!n) { n = String(1 + Math.floor(Math.random() * 9998)); localStorage.setItem('tscc-no', n); } } catch (e) { n = String(1 + Math.floor(Math.random() * 9998)); }
    el.textContent = el.getAttribute('data-cardno') + ' ' + ('000' + n).slice(-4);
  });
  var cn = $('[data-cardname]'), cnOut = $('[data-cardname-out]');
  if (cn && cnOut) { var cn0 = cnOut.textContent; cn.addEventListener('input', function () { cnOut.textContent = cn.value.trim().slice(0, 26) || cn0; }); }

  /* ---------- E-mail forms: checked here first, then sent to the shop ---------- */
  $$('form[data-mail]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var n = $('.note', f) || $('.note', f.parentElement), inp = $('input[type=email]', f);
      if (inp && !/^\S+@\S+\.\S+$/.test(inp.value)) {
        e.preventDefault();
        if (n) n.textContent = f.getAttribute('data-bad');
        inp.setAttribute('aria-invalid', 'true'); inp.focus();
      } else if (inp) inp.removeAttribute('aria-invalid');
    });
  });

  /* ---------- Numbered rows: on a touch screen the row nearest the middle of the window is the lit one ---------- */
  var rows = $$('.steps li, .tenet');
  if (rows.length && !FINE) {
    var rt = false, lit = null;
    var light = function () {
      rt = false; var mid = innerHeight / 2, best = null, d = 1e9;
      rows.forEach(function (li) { var b = li.getBoundingClientRect(), k = Math.abs(b.top + b.height / 2 - mid); if (b.bottom > 0 && b.top < innerHeight && k < d) { d = k; best = li; } });
      if (d > innerHeight * 0.3) best = null;
      if (best !== lit) { if (lit) lit.classList.remove('is-on'); if (best) best.classList.add('is-on'); lit = best; }
    };
    addEventListener('scroll', function () { if (!rt) { rt = true; requestAnimationFrame(light); } }, { passive: true });
    light();
  }

  /* ---------- Reels ---------- */
  var vids = $$('.reel video');
  vids.forEach(function (v) { v.removeAttribute('controls'); v.muted = true; });
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !RM) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); if (!v.muted) { v.muted = true; sync(); } }
      });
    }, { threshold: 0.55 });
    vids.forEach(function (v) { vio.observe(v); });
  }
  function sync() { $$('.reel').forEach(function (r) { var b = $('button', r), v = $('video', r); if (!b || !v) return; b.setAttribute('aria-pressed', String(!v.muted)); b.firstChild.textContent = v.muted ? b.getAttribute('data-off') : b.getAttribute('data-on'); }); }
  $$('.reel button').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = $('video', b.closest('.reel')), was = v.muted;
      vids.forEach(function (o) { o.muted = true; });
      v.muted = !was; if (RM || v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      sync();
    });
  });

  /* ---------- Cart: Shopify's cart, drawn by the cart-drawer section ---------- */
  var cartEl = $('.cart'), bodyEl = $('[data-cart-body]'), liveEl = $('[data-cart-live]'), lastFocus = null;
  var SID = cartEl ? cartEl.getAttribute('data-section-id') : '';
  var URLS = cartEl ? { add: cartEl.getAttribute('data-add-url'), change: cartEl.getAttribute('data-change-url'), root: cartEl.getAttribute('data-root-url') } : {};
  var INERT = 'main, .hd, .dock, .foot, .stick';
  function swap(html) {
    if (!html || !bodyEl) return;
    var nb = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-body]');
    if (!nb) return;
    bodyEl.innerHTML = nb.innerHTML;
    var n = nb.getAttribute('data-count');
    $$('[data-cart-n]').forEach(function (b) { b.textContent = n; });
    if (liveEl) liveEl.textContent = nb.getAttribute('data-live') || '';
  }
  function refresh() {
    if (!cartEl) return;
    fetch(URLS.root + '?sections=' + SID, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (j) { swap(j[SID]); }).catch(function () {});
  }
  function send(url, data) {
    data.sections = SID; data.sections_url = location.pathname;
    cartEl.classList.add('busy');
    return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { cartEl.classList.remove('busy'); if (j.sections) swap(j.sections[SID]); return j; }, function (err) { cartEl.classList.remove('busy'); throw err; });
  }
  function openCart(from) {
    if (!cartEl) return; lastFocus = from || doc.activeElement; root.classList.add('cart-open');
    $$(INERT).forEach(function (e) { e.inert = true; });
    setTimeout(function () { $('.cart__x').focus(); }, 60);
  }
  function closeCart() {
    root.classList.remove('cart-open'); $$(INERT).forEach(function (e) { e.inert = false; });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (!cartEl || !f.matches || !f.matches('form[data-add-form]')) return;
    e.preventDefault();
    var id = (f.elements.id || {}).value, q = +((f.elements.quantity || {}).value) || 1;
    var btn = e.submitter || $('[type=submit]', f), note = $('[data-add-note]', f);
    if (note) note.textContent = '';
    send(URLS.add, { items: [{ id: +id, quantity: q }] }).then(function () {
      $$('.cartb, .dock [data-cart-open]').forEach(function (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
      openCart(btn);
    }, function (err) {
      var msg = (err && (err.description || err.message)) || '';
      if (note) note.textContent = msg; else if (liveEl) liveEl.textContent = msg;
    });
  });
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cart-open], [data-cart-close], [data-q], [data-rm], [data-step], [data-stick-add]') : null; if (!t) return;
    if (t.hasAttribute('data-cart-open')) { if (!cartEl) return; e.preventDefault(); openCart(t); }
    else if (t.hasAttribute('data-cart-close')) closeCart();
    else if (t.hasAttribute('data-q')) {
      var key = t.getAttribute('data-key'), d = +t.getAttribute('data-q'), now = +t.getAttribute('data-now');
      send(URLS.change, { id: key, quantity: Math.max(0, now + d) }).then(function () {
        var again = $$('[data-q="' + d + '"]', cartEl).filter(function (b) { return b.getAttribute('data-key') === key; })[0];
        (again || $('.cart__x')).focus();
      }, function () { refresh(); });
    } else if (t.hasAttribute('data-rm')) {
      send(URLS.change, { id: t.getAttribute('data-rm'), quantity: 0 }).then(function () { $('.cart__x').focus(); }, function () { refresh(); });
    } else if (t.hasAttribute('data-step')) {
      var o = $('[data-qty]'), inp = $('[data-qty-input]'), v = clamp((+o.textContent || 1) + (+t.getAttribute('data-step')), 1, 9);
      o.textContent = v; if (inp) inp.value = v;
    } else if (t.hasAttribute('data-stick-add')) {
      var pf = $('form[data-product-form]'); if (pf) { if (pf.requestSubmit) pf.requestSubmit($('[data-main-add]', pf)); else pf.submit(); }
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (!root.classList.contains('cart-open')) return;
    if (e.key === 'Escape') closeCart();
    if (e.key === 'Tab') { var fs = $$('button, a[href]', cartEl).filter(function (x) { return x.offsetParent !== null; }); if (!fs.length) return; var a = fs[0], z = fs[fs.length - 1]; if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); } }
  });
  window.TSCC = { open: openCart, close: closeCart, refresh: refresh };

  /* ---------- Product page ---------- */
  var gal = $('.gal__t');
  if (gal) {
    var slides = $$('li', gal), ths = $$('.gal__th button');
    var go = function (i) { gal.scrollTo({ left: slides[i].offsetLeft - gal.offsetLeft, behavior: RM ? 'auto' : 'smooth' }); };
    ths.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
    if ('IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { var i = slides.indexOf(en.target); ths.forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); }); } }); }, { root: gal, threshold: 0.6 });
      slides.forEach(function (s) { gio.observe(s); });
    }
    var pick = function (el, scroll) {
      var mid = el.getAttribute('data-media');
      var i = mid ? slides.findIndex(function (s) { return s.getAttribute('data-media-id') === mid; }) : -1;
      if (scroll && i > -1) go(i);
      var sv = $('[data-stick-v]'); if (sv) sv.textContent = el.getAttribute('data-label') || '';
      var pr = el.getAttribute('data-price');
      if (pr) $$('[data-price]').forEach(function (p) { p.textContent = pr; });
      $$('[data-price-note]').forEach(function (p) { p.hidden = el.getAttribute('data-priced') === 'true'; });
      var ok = el.getAttribute('data-available') !== 'false';
      $$('[data-main-add], [data-stick-add]').forEach(function (b) { b.disabled = !ok; });
      var vid = el.value;
      if (vid && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', vid); history.replaceState(null, '', u); }
    };
    $$('input[name=id][type=radio]').forEach(function (r) { r.addEventListener('change', function () { pick(r, true); }); });
    var sel = $('select[name=id]');
    if (sel) sel.addEventListener('change', function () { pick(sel.options[sel.selectedIndex], true); });
    var main = $('[data-main-add]'), stick = $('.stick');
    if (main && stick && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { stick.classList.toggle('on', !es[0].isIntersecting); }).observe(main);
  }
})();
